fragment ImageTextFragment on imageText_Entry {
  typeHandle
  image {
    ...CraftAssetFragment
  }
  invert
  alt
  heading
  body
  guestOnly
  useImageLegend
  cta {
    ...LinkFragment
  }
}
